import React from 'react';
import { ArrowRight, Sparkles } from 'lucide-react';

const JournalSection = () => {
  const articles = [
    {
      id: 1,
      title: "The Heritage Craft: Preserving & Caring for Pure Silk Kanjivarams",
      category: "Saree Care & Heritage",
      date: "August 2026",
      readTime: "4 min read",
      image: "https://images.unsplash.com/photo-1610030469983-98e550d6193c?auto=format&fit=crop&q=80&w=800",
    },
    {
      id: 2,
      title: "Styling Antique Temple Jewelry with Contemporary Silks",
      category: "Jewelry Guide",
      date: "July 2026",
      readTime: "5 min read",
      image: "https://images.unsplash.com/photo-1599643478518-a784e5dc4c8f?auto=format&fit=crop&q=80&w=800",
    },
  ];

  return (
    <section className="mb-16 sm:mb-20">
     

      {/* Articles Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {articles.map((art) => (
          <div
            key={art.id}
            className="group cursor-pointer bg-[#FDFBF7] rounded-3xl overflow-hidden border border-[#E8DFC8] hover:shadow-lg hover:border-[#6B1320]/40 transition-all duration-300 flex flex-col justify-between"
          >
            <div>
           
              {/* Content Body */}
              <div className="p-6">
                <div className="flex items-center space-x-3 text-[10px] text-[#7A6B5D] font-serif font-bold uppercase tracking-wider mb-2">
                  <span>{art.date}</span>
                  <span>•</span>
                  <span>{art.readTime}</span>
                </div>
                <h3 className="text-base font-serif font-bold text-[#4A0E17] group-hover:text-[#6B1320] transition-colors leading-snug">
                  {art.title}
                </h3>
              </div>
            </div>

            {/* Read Story Link */}
            <div className="px-6 pb-6 pt-0 flex items-center space-x-2 text-xs font-serif font-bold text-[#4A0E17] group-hover:text-[#6B1320]">
              <span>Read Story</span>
              <ArrowRight className="w-3.5 h-3.5 group-hover:translate-x-1 transition-transform" />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default JournalSection;